<template>
  <div>
    <div
      v-if="role === roles.SUPER_ADMIN"
      class="docUpload"
    >
      <h2>System Upload</h2>
      <excel-uploader />
      <hr class="hr-line mt-4">
      <h2>Document Uploads</h2>
      <div class="row flex items-center">
        <button
          class="primary button"
          @click="recognitionHandler"
        >
          Enqueue recognition
        </button>
        <button
          class="primary button tooltip has-tooltip-right has-tooltip-arrow"
          :data-tooltip="'Should be used after text recognition'"
          @click="processHandler"
        >
          Process uploaded documents
        </button>

        <ExcelLetterUploader />
      </div>
      <hr class="hr-line mt-4">
      <div
        class="modal"
        :class="{ 'is-active': isOpenModal }"
      >
        <div
          class="modal-background"
          @click="hideModal"
        />
        <div class="modal-content">
          <div class="box">
            <h5>Information</h5>
            <div class="row">
              <h6>Letters:</h6>
              <p>Saved</p>
              <div v-if="letters.saved.length >= 1">
                <p
                  v-for="item in letters.saved"
                  :key="item"
                >
                  {{ item }}
                </p>
              </div>
              <div v-else>
                <p>0</p>
              </div>
              <p>Errors</p>
              <div v-if="Object.keys(letters.errors).length >= 1">
                <p
                  v-for="item in Object.keys(letters.errors)"
                  :key="item"
                >
                  {{ item }} - {{ letters.errors[item] }}
                </p>
              </div>
              <div v-else>
                <p>0</p>
              </div>
            </div>
            <div class="row">
              <h6>Usps:</h6>
              <p>Saved</p>
              <div v-if="usps.saved.length >= 1">
                <p
                  v-for="item in usps.saved"
                  :key="item"
                >
                  {{ item }}
                </p>
              </div>
              <div v-else>
                <p>0</p>
              </div>
              <p>Errors</p>
              <div v-if="usps.errors.length >= 1">
                <p
                  v-for="item in usps.errors"
                  :key="item"
                >
                  {{ item }}
                </p>
              </div>
              <div v-else>
                <p>0</p>
              </div>
            </div>
            <div
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <button
                class="button is-white"
                @click="hideModal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="hideModal"
        />
      </div>
    </div>
    <div
      v-if="role === roles.SUPER_ADMIN"
      class="docUpload__sms"
    >
      <h2>Auto Agent</h2>
      <div class="docUpload__sms-row">
        <div class="docUpload__sms-col">
          <p
            class=""
            style="margin: 10px 0"
          >
            EMAIL Auto Agent Status: {{ agentEmail.isEmailTriggerOn ? "On" : "Off" }}
          </p>

          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              value=""
              class="sr-only peer"
              :checked="agentEmail.isEmailTriggerOn"
              @click="emailHandler"
            >
            <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600" />
          </label>
        </div>
        <div class="docUpload__sms-col d-flex ml-col">
          <p class="label">
            Emails in the queue:
          </p>
          <div class="ml-50 d-flex fd-column">
            <p class="label">
              {{ agentEmail.emailsInQueue }}
            </p>
            <button
              :class="agentEmail.isLoading ? 'btn button is-loading': 'button primary'"
              @click="getAgentEmailStatus"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
      <div class="docUpload__sms-row">
        <div class="docUpload__sms-col">
          <p
            class=""
            style="margin: 10px 0"
          >
            SMS Auto Agent Status: {{ agentSms.isSmsTriggerOn ? "On" : "Off" }}
          </p>

          <label class="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              value=""
              class="sr-only peer"
              :checked="agentSms.isSmsTriggerOn"
              @click="smsHandler"
            >
            <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600" />
          </label>
        </div>
        <div class="docUpload__sms-col d-flex ml-col">
          <p class="label">
            SMS Messages in the queue:
          </p>
          <div class="ml-50 d-flex fd-column">
            <p class="label">
              {{ agentSms.smsInQueue }}
            </p>
            <button
              :class=" agentSms.isLoading ? 'btn button is-loading': 'button primary'"
              @click="getAgentSmsStatus"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
      <hr class="hr-line mt-4">
    </div>
    <div
      v-if="role === roles.SUPER_ADMIN"
      class="docUpload"
    >
      <div class="row flex items-center">
        <button
          class="primary button"
          :disabled="adsLoading"
          @click="completeAdsHandler"
        >
          Complete Ads (past 14 days)
        </button>
      </div>
    </div>
    <!-- 1231231 -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN || role === roles.CS_ADMIN"
      class="upload_file"
    >
      <h2>
        Report Documents
      </h2>
      <div class="upload-image">
        <input
          id="file-input"
          ref="uploadInput"
          type="file"
          class="button primary is-outlined file-uploader"
          @change="uploadImage"
        >
      </div>
      <a
        href="#"
        :class="
          ` ${
            fileLoader
              ? 'is-loading button primary'
              : 'button primary is-outlined'
          } `
        "
        @click="handleAddClickManual()"
      >Check</a>
    </div> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="upload_file"
    >
      <h2>
        Send SiteLink Notes
      </h2>
      <div class="upload-image">
        <input
          id="file-input"
          ref="uploadSiteLink"
          type="file"
          class="button primary is-outlined file-uploader"
          @change="uploadSiteLink"
        >
      </div>
      <a
        href="#"
        :class="{
          'is-loading button primary': isSiteLinkLoading,
          'button primary is-outlined': !isSiteLinkLoading
        }"
        @click="sendSiteLinkFile()"
      >Send</a>
    </div>
    <hr class="hr-line mt-4"> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="upload_file"
    >
      <h2>
        QA Report
      </h2>
      <div class="upload-image">
        <input
          id="file-input"
          ref="uploadInputForQA"
          type="file"
          class="button primary is-outlined file-uploader"
          @change="uploadImageForQA"
        >
      </div>
      <a
        href="#"
        :class="{
          'is-loading button primary': isSiteLinkLoading,
          'button primary is-outlined': !isSiteLinkLoading
        }"
        @click="handleAddClickManualForQA()"
      >Check</a>
    </div>
    <hr class="hr-line mt-4"> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="email__report"
    >
      <h2>
        Email Report
      </h2>
      <div class="email__inputs">
        <div class="email__input-wrapper">
          <label for="emailStartDate">Date from</label>
          <input
            id="emailStartDate"
            v-model="emailStartDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
        <div class="email__input-wrapper">
          <label for="emailEndDate">Date to</label>
          <input
            id="emailEndDate"
            v-model="emailEndDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
      </div>
      <button
        class="button primary is-outlined"
        @click="getEmailReport"
      >
        Get Report
      </button>
    </div>
    <hr class="hr-line mt-4"> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="email__report"
    >
      <h2>
        Export Letters
      </h2>
      <div class="email__inputs">
        <div class="email__input-wrapper">
          <label for="emailStartDate">Date from</label>
          <input
            id="emailStartDate"
            v-model="emailReportStartDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
        <div class="email__input-wrapper">
          <label for="emailEndDate">Date to</label>
          <input
            id="emailEndDate"
            v-model="emailReportEndDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
      </div>
      <button
        class="button primary is-outlined"
        @click="getReportLetters"
      >
        Get Letters
      </button>
    </div> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="email__report"
    >
      <h2>
        Restart reports
      </h2>
      <div class="email__inputs">
        <div class="email__input-wrapper">
          <label for="emailStartDate">Date from</label>
          <input
            id="emailStartDate"
            v-model="restartReportStartDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
        <div class="email__input-wrapper">
          <label for="emailEndDate">Date to</label>
          <input
            id="emailEndDate"
            v-model="restartReportEndDate"
            type="date"
            class="input is-info is-outlined email-input"
          >
        </div>
      </div>
      <button
        class="button primary is-outlined"
        @click="getRestartReports"
      >
        Get Restart Reports
      </button>
    </div> -->
    <!-- <div
      v-if="role === roles.SUPER_ADMIN"
      class="email__report"
    >
      <h2>
        Pending Release reports
      </h2>
      <button
        class="button primary is-outlined"
        @click="getPendingReleaseReports"
      >
        Get Pending Release Reports
      </button>
    </div> -->
    <div
      class="modal"
      :class="{'is-active' : isShowExcelModal}"
    >
      <div
        class="modal-background"
        @click="hideExcelModal()"
      />
      <div class="modal-content">
        <div class="box">
          <div v-if="Object.keys(excelResponse.saved).length">
            <h6>Saved messages</h6>
            <div
              v-for="(key, idx) in Object.keys(excelResponse.saved)"
              :key="'failedItem' + idx"
            >
              <div>
                <p>
                  {{ key }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="Object.keys(excelResponse.errors).length">
            <h6>Error messages</h6>
            <div
              v-for="(key, idx) in Object.keys(excelResponse.errors)"
              :key="'failedItem' + idx"
            >
              <div>
                <span>{{ key }}.</span>
                <p>
                  {{ excelResponse.errors[key] }}
                </p>
              </div>
            </div>
          </div>

          <p
            class="control has-text-right"
            style="mt-4"
          >
            <button
              type="button"
              class="button is-white"
              @click="hideExcelModal()"
            >
              Close
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideExcelModal()"
      />
    </div>
  </div>
</template>
<script>
import DocUploadService from '../../services/docUpload.service';
import { Roles } from '../../constants';
import { isExcel } from '../../utils/validationUtils';
import ExcelUploader from '../dashboard/table/ExcelUploaderNew';
import ExcelLetterUploader from '../dashboard/table/ExcelLetterUploader';

const docUploadService = new DocUploadService();

export default {
  name: 'DocUpload',
  components: {
    ExcelUploader,
    ExcelLetterUploader
  },
  data() {
    return {
      agentEmail: {
        isEmailTriggerOn: false,
        emailsInQueue: 0,
        isLoading: false
      },
      agentSms: {
        isSmsTriggerOn: false,
        smsInQueue: 0,
        isLoading: false
      },
      file: null,
      fileForQA: null,
      roles: Roles,
      fileLoader: false,
      fileLoaderForQA: false,
      isOpenModal: false,
      isSiteLinkLoading: false,
      isShowExcelModal: false,
      usps: {
        saved: [],
        errors: []
      },
      letters: {
        saved: [],
        errors: []
      },
      role: this.$store.state.user.role,
      emailReportStartDate: '',
      emailStartDate: '',
      emailReportEndDate: '',
      restartReportStartDate: '',
      restartReportEndDate: '',
      emailEndDate: '',
      siteLinkFile: '',
      excelResponse: {
        saved: {},
        errors: {}
      },
      adsLoading: false
    };
  },
  mounted() {
    this.getCurrentStatusOfAgents();
  },
  methods: {
    async getReportLetters() {
      if (!this.emailReportEndDate || !this.emailReportStartDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      try {
        const res = await this.$store.dispatch('getExcelFiles', {
          url: 'report/lien_list_usps',
          data: {
            start: this.emailReportStartDate,
            end: this.emailReportEndDate
          }
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.emailReportEndDate = '';
        this.emailReportStartDate = '';
      }
    },
    async getRestartReports() {
      if (!this.restartReportStartDate || !this.restartReportEndDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      try {
        const res = await this.$store.dispatch('getExcelFiles', {
          url: 'report/restarts',
          data: {
            start: this.restartReportStartDate,
            end: this.restartReportEndDate
          }
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.restartReportEndDate = '';
        this.restartReportStartDate = '';
      }
    },
    async getPendingReleaseReports() {
      try {
        const res = await this.$store.dispatch('getExcelFileByGetMethod', {
          url: 'report/pending_release'
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      }
    },
    getEmailReport() {
      if (!this.emailEndDate || !this.emailStartDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      const url = `${this.$store.state.API_URL}report/email_possible_reasons`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: JSON.stringify({
          start: this.emailStartDate,
          end: this.emailEndDate
        })
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.$root.$emit('showToast', {
            message: 'downloaded successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.emailEndDate = '';
          this.emailStartDate = '';
        })
        .catch((err) => {
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    getCurrentStatusOfAgents() {
      this.getAgentEmailStatus();
      this.getAgentSmsStatus();
    },
    getAgentSmsStatus() {
      this.agentSms.isLoading = true;
      docUploadService.getAgentStatus('sms').then((res) => {
        if (res.data.status === 'success') {
          this.agentSms.isSmsTriggerOn = res.data.result.on;
          this.agentSms.smsInQueue = res.data.result.count;
        }
        this.agentSms.isLoading = false;
      }).catch((err) => {
        console.log(err);
        this.agentSms.isLoading = false;
      });
    },
    getAgentEmailStatus() {
      this.agentEmail.isLoading = true;
      docUploadService.getAgentStatus('email').then((res) => {
        if (res.data.status === 'success') {
          this.agentEmail.isEmailTriggerOn = res.data.result.on;
          this.agentEmail.emailsInQueue = res.data.result.count;
        }
        this.agentEmail.isLoading = false;
      }).catch((err) => {
        console.log(err);
        this.agentEmail.isLoading = false;
      });
    },
    uploadImage(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInput.value = '';
        this.file = '';
        return;
      }
      this.file = file;
    },
    uploadSiteLink(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadSiteLink.value = '';
        this.siteLinkFile = '';
        return;
      }
      this.siteLinkFile = file;
    },
    uploadImageForQA(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInputForQA.value = '';
        this.fileForQA = '';
        return;
      }
      this.fileForQA = file;
    },
    handleAddClickManualForQA() {
      if (!this.fileForQA) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      this.fileLoaderForQA = true;
      const formData = new FormData();
      formData.append('file', this.fileForQA);
      const url = `${this.$store.state.API_URL}report/qa`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: formData
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.fileLoaderForQA = false;
          this.$root.$emit('showToast', {
            message: 'File checked successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.$refs.uploadInputForQA.value = '';
          this.fileForQA = '';
        })
        .catch((err) => {
          this.fileLoaderForQA = false;
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    handleAddClickManual() {
      if (!this.file) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      this.fileLoader = true;
      const formData = new FormData();
      formData.append('file', this.file);
      const url = `${this.$store.state.API_URL}docupload/check`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: formData
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: 'File checked successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.$refs.uploadInput.value = '';
          this.file = '';
        })
        .catch((err) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    async sendSiteLinkFile() {
      if (!this.siteLinkFile) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      try {
        this.isSiteLinkLoading = true;
        const formData = new FormData();
        formData.append('file', this.siteLinkFile);
        const res = await this.$store.dispatch('uploadExcelFile', {
          url: 'sitelink/insert_note',
          data: formData
        });
        this.openExcelModal();
        this.excelResponse = res.result;
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.response.data.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.isSiteLinkLoading = false;
      }
    },
    openExcelModal() {
      this.isShowExcelModal = true;
    },
    hideExcelModal() {
      this.isShowExcelModal = false;
    },
    showModal() {
      this.isOpenModal = true;
    },
    hideModal() {
      this.isOpenModal = false;
    },
    recognitionHandler() {
      if (this.role) {
        docUploadService
          .getRecognition()
          .then((res) => {
            if (res?.data?.status === 'success') {
              this.$root.$emit('showToast', {
                message: res?.data?.message,
                options: { cssClass: 'is-success', duration: 10000 }
              });
            } else {
              this.$root.$emit('showToast', {
                message:
                  'Impossible to perform this action. Be sure to be connected and to have access to this action',
                options: { cssClass: 'is-danger', duration: 10000 }
              });
            }
          })
          .catch(function () {
            this.$root.$emit('showToast', {
              message:
                'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          });
      }
    },
    emailHandler() {
      this.agentEmail.isEmailTriggerOn = !this.agentEmail.isEmailTriggerOn;
      docUploadService.toggleAgent('email').then((res) => {
        if (res?.data?.status === 'success') {
          this.$root.$emit('showToast', {
            message: res?.data?.message,
            options: { cssClass: 'is-success', duration: 10000 }
          });
          this.getAgentEmailStatus();
        } else {
          this.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        }
      });
    },
    smsHandler() {
      this.agentSms.isSmsTriggerOn = !this.agentSms.isSmsTriggerOn;
      docUploadService.toggleAgent('sms').then((res) => {
        if (res?.data?.status === 'success') {
          this.$root.$emit('showToast', {
            message: res?.data?.message,
            options: { cssClass: 'is-success', duration: 10000 }
          });
          this.getAgentSmsStatus();
        } else {
          this.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        }
      });
    },
    processHandler() {
      if (this.role) {
        docUploadService
          .getProcess()
          .then((res) => {
            if (res?.data?.status === 'success') {
              this.usps = res?.data?.result?.usps;
              this.letters = res?.data?.result?.letters;
              this.showModal();
            } else {
              this.$root.$emit('showToast', {
                message:
                  'Impossible to perform this action. Be sure to be connected and to have access to this action',
                options: { cssClass: 'is-danger', duration: 10000 }
              });
            }
          })
          .catch(function () {
            this.$root.$emit('showToast', {
              message:
                'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          });
      }
    },
    async completeAdsHandler() {
      try {
        this.adsLoading = true;

        await docUploadService.completeAds();

        this.$root.$emit('showToast', {
          message: 'Ads steps for past 14 days completed successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (error) {
        console.error('[Complete Ads]', error);
      } finally {
        this.adsLoading = false;
      }
    }
  }
};
</script>
<style
  scoped
  src="../../../public/assets/css/bulma-extension/bulma-tooltip.min.css"
></style>
<style scoped lang="scss">
h2 {
  font-size: 26px;
}
.row {
  margin-top: 20px;
}
.row button {
  margin-right: 10px;
  padding: 6px 13px;
}

.modal {
  .modal-content {
    overflow: visible;
    .box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .upload-image {
        margin-top: 15px;
        display: flex;
        align-items: center;

        .image-preview {
          margin-left: 15px;
          width: 50px;
          height: 50px;
          border-radius: 5px;
          cursor: pointer;
          transition: transform 0.3s;
          z-index: 1;

          &:hover {
            transform: scale(2.5);
            border-radius: 0;
          }
        }
      }
    }
  }
}
.btn{
  background-color: rgb(41, 121, 255);
  border-radius: 5px;
  padding: 8px 15px;
  border: none;
  color: white;
  cursor: pointer;
}
.docUpload__sms-row{
  display: flex;
  align-items: center;
}
.docUpload__sms-col{
  width: 400px;
}
.hr-line {
  @apply
    h-px
    bg-muted-300 dark:bg-muted-600;
}
.d-flex{
  display: flex;
  align-items: center;
}
.fd-column{
  flex-direction: column;
}
.label{
  margin: 0;
}
.ml-50{
  margin-left: auto;
}
.toggle__switch {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 56px;
}

.toggle__input {
  display: none;
}

.toggle__slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.toggle__slider:before {
  position: absolute;
  content: "";
  height: 56px;
  width: 96px;
  left: 0px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.toggle__input:checked + .toggle__slider {
  background-color: rgb(41, 121, 255);
}

.toggle__input:focus + .toggle__slider {
  box-shadow: 0 0 1px rgb(41, 121, 255);
}

.toggle__input:checked + .toggle__slider:before {
  -webkit-transform: translateX(65px);
  -ms-transform: translateX(65px);
  transform: translateX(65px);
}

.toggle__slider.toggle__round {
  border-radius: 14px;
}

.toggle__slider.toggle__round:before {
  border-radius: 15px;
}
.email__report{
  margin-bottom: 80px;
}
.email__inputs{
  display: flex;
  max-width: 400px;
}
.email__input{
  margin-top: 8px;
}
</style>
